import { atom } from 'recoil';

export const PricingPopupState = atom({
  key: 'PricingPopupState',
  default: false,
});
